export enum NEWSLETTER_PERMISSIONS {
    NEWSLETTER_EDIT = 'NEWSLETTER_EDIT',
    NEWSLETTER_DELETE = 'NEWSLETTER_DELETE',
}
